const DRAFT_KEY_PREFIX = 'matta-nuu-inventory-draft-'

function draftKey(inventoryId) {
  return `${DRAFT_KEY_PREFIX}${inventoryId}`
}

export function serializeDraftFields(inventory = {}) {
  return JSON.stringify({
    values: inventory.values || {},
    completed_storage_areas_ids: inventory.completed_storage_areas_ids || [],
  })
}

export function isDraftDifferent(draft, inventory) {
  if (!draft) return false
  return serializeDraftFields(draft) !== serializeDraftFields(inventory)
}

export function readDraft(inventoryId) {
  if (inventoryId == null) return null
  try {
    const raw = localStorage.getItem(draftKey(inventoryId))
    if (!raw) return null
    const draft = JSON.parse(raw)
    if (!draft || draft.inventoryId == null) return null
    return draft
  } catch (error) {
    return null
  }
}

export function writeDraft({
  inventoryId,
  sessionId,
  values,
  completed_storage_areas_ids,
}) {
  if (inventoryId == null) return
  const payload = {
    inventoryId,
    sessionId,
    updatedAt: new Date().toISOString(),
    values: values || {},
    completed_storage_areas_ids: completed_storage_areas_ids || [],
  }
  localStorage.setItem(draftKey(inventoryId), JSON.stringify(payload))
}

export function clearDraft(inventoryId) {
  if (inventoryId == null) return
  localStorage.removeItem(draftKey(inventoryId))
}

export function hasDraft(inventoryId) {
  return !!readDraft(inventoryId)
}

export function listDraftsForSession(sessionId) {
  if (sessionId == null) return []
  const sessionIdStr = String(sessionId)
  const draftsByInventoryId = {}
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i)
    if (!key || !key.startsWith(DRAFT_KEY_PREFIX)) continue
    try {
      const draft = JSON.parse(localStorage.getItem(key))
      if (draft && String(draft.sessionId) === sessionIdStr) {
        draftsByInventoryId[String(draft.inventoryId)] = draft
      }
    } catch (error) {
      // skip invalid entries
    }
  }
  return Object.values(draftsByInventoryId).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
}
